import type { InputHTMLAttributes } from 'react';
import controlStyles from './wizard-controls.module.css';

export interface WizardInputProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'className'> {
  onChange?: (value: string) => void;
  hasError?: boolean;
}

export default function WizardInput({
  onChange,
  hasError = false,
  ...props
}: WizardInputProps) {
  return (
    <input
      {...props}
      className={`${controlStyles.input} ${hasError ? controlStyles.inputError : ''}`.trim()}
      onChange={(event) => onChange?.(event.target.value)}
    />
  );
}
